import { i18n } from 'lib/i18n.js';

export default {
  props: ['body_1', 'body_2', 'mobile_body_1', 'mobile_body_2'],
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    body() {
      return this.isOpen ? this.body_2 : this.body_1;
    },
    mobileBody() {
      return this.isOpen ? this.mobile_body_2 : this.mobile_body_1;
    },
    buttonText() {
      return this.isOpen
        ? this.$t('about_fenty_beauty.read_less')
        : this.$t('about_fenty_beauty.read_more');
    },
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
  },
  i18n,
};
